import styled from "styled-components";

export const Nav = styled.nav`
  height: 6rem;

  .burger-menu {
    position: relative;
    .navbar-menu {
      padding: 0;
      .navbar-start {
        .navbar-dropdown {
          padding-top: 0 !important;
          padding-bottom: 0 !important;
          div {
            .navbar-item {
              padding: 1rem;
              border-bottom: 1px solid #4a4a4a;
            }
          }
        }
      }
    }
  }
  .navbar-wrapper {
    height: 100%;
    width: 100%;
  }

  .navbar-wrapper {
    .navbar-content {
      display: flex;
      align-items: center;
      height: 100%;
      width: 100%;
      .navbar-item {
        .image {
          border-radius: 0.5rem;
          transform: rotate(-45deg);
          img {
            object-fit: contain;
            max-height: 100%;
            transform: rotate(45deg);
          }
        }
      }
    }
  }
  .notburger-menu {
    display: none;
  }

  @media screen and (min-width: 768px) {
    .navbar-wrapper {
      width: 98%;
      margin: 0 auto;
    }
  }

  @media screen and (min-width: 1024px) {
    .navbar-wrapper {
      width: 90%;
      margin: 0 auto;
      .navbar-content {
        .navbar-item {
          .image {
            cursor: pointer;
          }
        }
      }
    }
    .burger-menu {
      display: none;
    }
    .notburger-menu {
      width: 100%;
      display: flex;
      flex-shrink: 1;
    }
    .navbar-dropdown {
      -moz-border-radius: 0px;
      -webkit-border-radius: 0 0 0.5rem 0.5rem;
      border-radius: 0 0 0.5rem 0.5rem;
    }
    .navbar-item:hover {
      color: #000000 !important;
    }
    /* .federationActive {
    display: ${({ $federationActive }) =>
      $federationActive ? "block" : "none"};
    transform: 0.3 ease-in-out;
    opacity: 1;
  }
  .bhActive {
    display: ${({ $bhActive }) => ($bhActive ? "block" : "none")};
    transform: 0.3 ease-in-out;
    opacity: 1;
  } */
  }
`;
